import { render, staticRenderFns } from "./activity-item-task.vue?vue&type=template&id=0a968a50"
import script from "./activity-item-task.vue?vue&type=script&lang=js"
export * from "./activity-item-task.vue?vue&type=script&lang=js"
import style0 from "./activity-item-task.vue?vue&type=style&index=0&id=0a968a50&prod&lang=css"
import style1 from "./activity-item-task.vue?vue&type=style&index=1&id=0a968a50&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports